import { Box, Divider, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultantOnboardingDialog from "../forms/ConsultantOnboarding/ConsultantOnboardingForm";
import BorrowerContent from "./BorrowerContent";
import LenderOnboardingForm from "../forms/LenderOnboarding/LenderOnboardingForm";
import { registerUser } from "../../API/API";
import { showToast } from "../common/Util/Util";
import { setUser } from "../../ReduxStore/UserSlice";
import { useDispatch, useSelector } from "react-redux";
import { openDashboardInNewTab } from "../../utils/navigationUtils";
import { useEffect } from "react";

const AddProfilePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const role = location?.state?.role || "borrower"; // fallback to borrower

  useEffect(() => {
   if (!role|| Object.keys(user?user:{}).length===0 || user.userType) {
      navigate("/");
    }
  })

  const handleAddProfile = (addProfileRequest) => {
    registerUser(addProfileRequest)
      .then((res) => {
        if (res?.statusCode === 200) {
          showToast(res.message, "success");
          localStorage.setItem("user", JSON.stringify(res.result));
          dispatch(setUser(res.result));
          openDashboardInNewTab();
          navigate("/");
        }
      })
      .catch((e) => {
        showToast("Oops! Something went wrong.", "error");
        console.error(e, "error");
      });
  };

  const renderContent = () => {
    switch (role) {
      case "borrower":
        return <BorrowerContent handleAddProfile={handleAddProfile} />;
      case "lender":
        return <LenderOnboardingForm handleAddProfile={handleAddProfile} />;
      case "consultant":
        return (
          <ConsultantOnboardingDialog handleAddProfile={handleAddProfile} />
        );
      default:
        return <Typography>Invalid role provided</Typography>;
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: "#004AAD",
          mb: 2,
        }}
      >
        {role.charAt(0).toUpperCase() + role.slice(1)} Onboarding
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {renderContent()}
    </Box>
  );
};

export default AddProfilePage;
